import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./styles.css";
import App from "./App";
import { BrandingProvider } from "./context/BrandingContext";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </HelmetProvider>
  </React.StrictMode>
);
